import { CheckboxTheme } from "./types";

export const checkbox: CheckboxTheme = {
    sizes: {
        XS: "1rem",
        S: "1.5rem",
        M: "1.6rem",
        L: "1.7rem",
        XL: "1.8rem",
    },
};
